import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Paths } from '../../enums';

@Component({
  selector: 'antim-autoware-top-nav',
  standalone: false,
  templateUrl: './top-nav.component.html',
  styleUrl: './top-nav.component.scss'
})
export class TopNavComponent {

  @Input() isMenuOpen = true;
  @Output() menuToggle: EventEmitter<any> = new EventEmitter();

  /**
   *
   * This method is called once, just before the component is build.
   * 
   * @param cartServiceProxy
   * @param router
   * @param wishListServiceProxy
   * 
   * @memberof TopNavComponent 
    */
  constructor(private router: Router) {
  }

  onHideShow(): void {
    this.menuToggle.emit(!this.isMenuOpen);
  }

  /**
   * Redirects to the wishlist page.
   * 
   * @memberof TopNavComponent
   */
  goToHomePage() {
    this.router.navigate(["/"]);
  }

  dashboard(){
    this.router.navigate([`${Paths.admin}/${Paths.dashboard}`]);
  }
}
